// extracted by css-extract-rspack-plugin
export default {"list":"SectionFilters-module__list__I7rUk"};